// src/pages/ContactPage.jsx
import React from 'react';
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { useToast } from '../contexts/ToastContext';
import '../css/ContactPage.css';

const ContactPage = () => {

    const form = useRef();
    const [statusMessage, setStatusMessage] = useState('');
    const { addToast } = useToast();

    const sendEmail = (e) => {
        e.preventDefault();
        setStatusMessage('');

        // Check if environment variables are defined
        if (!process.env.REACT_APP_EMAILJS_SERVICE_ID || !process.env.REACT_APP_EMAILJS_TEMPLATE_ID || !process.env.REACT_APP_EMAILJS_PUBLIC_KEY) {
            console.error('EmailJS environment variables are not set');
            setStatusMessage('Configuration error, please contact support.');
            return;
        }

        emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, form.current, process.env.REACT_APP_EMAILJS_PUBLIC_KEY)
            .then((result) => {
                console.log('Email sent successfully:', result);
                setStatusMessage('Message sent successfully!');
                addToast("Message sent successfully !!!", 'success');
            }, (error) => {
                console.error('EmailJS error:', error);
                setStatusMessage('Failed to send message, please try again.');
            });
    };

    return (
        <div className="contact-page">
            <header className="contact-banner">
                <div className="banner-inner">
                    <div className="banner-text">
                        <h1>Contact Us</h1>
                        <p>We're here to help you — reach out anytime</p>
                    </div>
                </div>
            </header>


            <div className="contact-content">
                <div className="contact-info">
                    <h2>Get in Touch</h2>

                    <div className="contact-item">
                        <div className="contact-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#0073e6" />
                            </svg>
                        </div>
                        <div>
                            <strong>Address:</strong>
                            <span>
                                Nearby Chaudhri Charan Singh College, Umararkhera, Orai, District Jalaun,
                                Uttar Pradesh – 285001
                            </span>
                        </div>
                    </div>

                    <div className="contact-item">
                        <div className="contact-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#0073e6" />
                            </svg>
                        </div>
                        <div>
                            <strong>Email:</strong>
                            <a href="mailto:metromenswear01@gmail.com">metromenswear01@gmail.com</a>
                        </div>
                    </div>

                    <div className="contact-item">
                        <div className="contact-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#0073e6" />
                            </svg>
                        </div>
                        <div>
                            <strong>Phone:</strong>
                            <a href="tel:9486217297">94862 17297</a>
                        </div>
                    </div>

                    <p className="contact-note">
                        For any queries, complaints, or support — feel free to reach out. We will get back to you as soon as possible.
                    </p>
                </div>

                <div className="contact-form">
                    <h2>Send us a Message</h2>
                    <form ref={form} onSubmit={sendEmail}>
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input type="text" id="name" name="name" placeholder='Enter your Name' required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input type="email" id="email" name="email" placeholder='Enter your valid Email ID' required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea id="message" name="message" rows="5" placeholder='Description' required></textarea>
                        </div>
                        <button type="submit" className="submit-btn">Send Message</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;
